module.exports = require('./helpers/bundle-url').getBundleURL('koVhS') + "CheckedBox.de8e4a62.svg";